<template>
  <page>
    <v-container fluid grid-list-sm>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xl6 lg6 xs6>
                          <v-autocomplete
                            :items="accounts"
                            v-model="filter.inter"
                            item-text="label"
                            item-value="value"
                            :label="label.inter"
                            :error-messages="errors.collect('filter.inter')"
                            data-vv-name="filter.inter"
                            :data-vv-as="label.inter"
                            clearable
                          >
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xl6 lg6 xs6>
                          <v-autocomplete
                            :items="scheme"
                            v-model="filter.scheme"
                            item-text="label"
                            item-value="value"
                            :label="label.scheme"
                            :error-messages="errors.collect('filter.scheme')"
                            data-vv-name="filter.scheme"
                            :data-vv-as="label.scheme"
                            clearable
                          >
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xl6 lg6 xs6>
                          <cal-picker v-model="filter.effDate" :label="label.effDate" :data-vv-as="label.effDate" data-vv-name="effDate"></cal-picker>
                        </v-flex>
                        <v-flex xl6 lg6 xs6>
                          <cal-picker v-model="filter.expDate" :label="label.expDate" :data-vv-as="label.expDate" data-vv-name="expDate"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark class="mb-2" @click="doNew">
                    New Permitted Scheme
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      v-bind:options.sync="pagination"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row">
                        <tr>
                          <td class="text-xs-left">{{ row.item.inter }}</td>
                          <td class="text-xs-left">{{ row.item.scheme }}</td>
                          <td class="text-xs-left">{{ row.item.defaultSchemeAE }}</td>
                          <td class="text-xs-left">{{ convertDate(row.item.effDate) }}</td>
                          <td class="text-xs-left">{{ convertDate(row.item.expDate) }}</td>
                          <td class="table-action-header">
                            <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Permitted Scheme per Intermediary?</p>
        <div class="queryValue">{{ selectedInterScheme.inter }} , {{ selectedInterScheme.scheme }}</div>
      </confirm>
    </v-container>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      accounts: [],
      scheme: [],
      totalItems: 0,
      toogleArray: [false],
      promptRemove: false,
      loading: false,
      headers: [
        { text: 'Intermediary', value: 'inter' },
        { text: 'Scheme', value: 'scheme' },
        { text: 'Default Scheme', value: 'defaultSchemeAE' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      label: {
        inter: 'Intermediary',
        scheme: 'Scheme',
        effDate: 'Effective Date',
        expDate: 'Expiry Date'
      },
      filter: {
        inter: null,
        scheme: null,
        effDate: null,
        expDate: null
      },
      selectedInterScheme: {
        inter: null,
        scheme: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('accounts')
      this.getCommonDataListDropDown('scheme')
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filter.inter = null
      this.filter.scheme = null
      this.filter.effDate = null
      this.filter.expDate = null
      this.fetchData(false)
    },
    async fetchData(options) {
      const apiURI = this.menu.interSchemeList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)
          if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
            messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
          }

          if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
            messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
          }

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((interScheme) => {
                const convertList = {
                  inter: interScheme.inter,
                  scheme: interScheme.scheme,
                  defaultSchemeAE: interScheme.defaultSchemeAE,
                  effDate: interScheme.effDate,
                  expDate: interScheme.expDate,
                  createdBy: interScheme.createdBy,
                  createdDate: interScheme.createdDate,
                  modifiedBy: interScheme.modifiedBy,
                  modifiedDate: interScheme.modifiedDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      const commit = {
        inter: null,
        scheme: null,
        defaultSchemeAE: null,
        effDate: null,
        expDate: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      }
      sessionStorage.setItem('interScheme', JSON.stringify(commit))
      this.$store.commit('INTERSCHEME_COMMIT_KEY', commit)
      this.$router.push({ name: 'interSchemeDetail' })
    },
    doReview(data) {
      const commit = {
        inter: data.inter,
        scheme: data.scheme,
        defaultSchemeAE: data.defaultSchemeAE,
        effDate: data.effDate,
        expDate: data.expDate,
        createdBy: data.createdBy,
        createdDate: data.createdDate,
        modifiedBy: data.modifiedBy,
        modifiedDate: data.modifiedDate
      }
      sessionStorage.setItem('interScheme', JSON.stringify(commit))
      this.$store.commit('INTERSCHEME_COMMIT_KEY', commit)
      this.$router.push({ name: 'interSchemeDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteInterScheme
          const expand = {
            inter: data.inter,
            scheme: data.scheme
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedInterScheme.inter = data.inter
          this.selectedInterScheme.scheme = data.scheme
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedInterScheme && this.selectedInterScheme.inter) {
        const apiURI = this.menu.deleteInterScheme
        if (apiURI) {
          const expand = {
            inter: this.selectedInterScheme.inter,
            scheme: this.selectedInterScheme.scheme
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.interScheme.menu
    }
  },
  watch: {
    pagination: function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
